module.exports = __webpack_public_path__ + "img/logoStockEmpty.5c63e974.png";